

import React, { useState, useEffect, useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import { EmbeddedCheckoutProvider, EmbeddedCheckout, useCheckout } from "@stripe/react-stripe-js";
import { fetchAuthSession } from 'aws-amplify/auth';
import { useAuthenticator } from '@aws-amplify/ui-react';






// const stripePromise = loadStripe("pk_test_51QjDQYJghU42dndgZ1cdF97e6rRxNPZs9T4lWxhj2h19jf7EisoUMNtEX8nHjnNJHCNYup1NeAicO7iiinUzh5nH00gKdcbb6Y");

const stripePromise = loadStripe("pk_live_51QjDQYJghU42dndgruuEdC41dBTsyZmQM2RVdgWU92ttInlq7UDmdtCSSCmpq5gab1QB7Ac0Xo3UN3w6Pc87CQQ7000rjlkps9");


const CheckoutForm = () => {
    const [clientSecret, setClientSecret] = useState(null);
    const { state } = useLocation();
    const navigate = useNavigate();  

    const { user, signOut } = useAuthenticator((context) => [context.user]);

  

    useEffect(() => {
        if (state?.selectedItems) {
            const formattedItems = state.selectedItems.map(item => ({
                price_id: item.id,
                quantity: item.quantity || 1  
            }));

            const fetchClientSecret = async () => {
                try {
                    const headers = { "Content-Type": "application/json" };

                    if (user){
                    const session = await fetchAuthSession();
                    const jwtToken = session.tokens.idToken;
                    headers["Authorization"] = `Bearer ${jwtToken}`;

                    }

                  
                    const response = await fetch(
                        "https://k985ig7yj1.execute-api.me-south-1.amazonaws.com/developed/create-checkout-session",
                        {
                            method: "POST",
                            mode: "cors",
                            headers,
                            body: JSON.stringify({ items: formattedItems }) 
                        }
                    );

                    if (!response.ok) {
                        throw new Error("Failed to fetch client secret");
                    }

                    const data = await response.json();
                    console.log(data)
                    if (data.clientSecret) {
                        setClientSecret(data.clientSecret);
                    } else {
                        throw new Error("Invalid clientSecret received");
                    }
                } catch (error) {
                    console.error("Error fetching client secret:", error);
                }
            };

            fetchClientSecret();
        }
    }, [state]);


    if (!stripePromise || !clientSecret) {
        return <p>Loading checkout...</p>; 
    }
  const handleSuccess = () => {
        // Handle successful checkout, e.g., navigate to a success page
        navigate("/success");  // Redirect to a success page, or display success message
    };

    const handleError = (error) => {
        console.error("Checkout failed:", error);
        // You can also display an error message to the user
    };
    return (
        <div className="checkout-page">
        <div id="checkout" >
            <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
                <EmbeddedCheckout 
                onPaymentSuccess={handleSuccess}  
                onPaymentError={handleError} /> 
            </EmbeddedCheckoutProvider>
        </div>
        </div>
    );
};

export default CheckoutForm;
